import { Locale } from '@goldwasserexchange/i18n';

export const subscribeToMailchimpNewsLetter = (props: {
  language: Locale,
  email: string,
  firstName: string,
  lastName: string,
}) => {
  const {
    language,
    email,
    firstName,
    lastName,
  } = props;
  const formData = new FormData();
  formData.append('u', '1cfa25ddab00dbeb69c78b15f');
  formData.append('id', language === Locale.FR ? '8638343092' : '12c9d0de24');
  formData.append('MERGE0', email);
  formData.append('MERGE1', firstName);
  formData.append('MERGE2', lastName);
  return fetch('https://goldwasserexchange.us6.list-manage.com/subscribe/post', { method: 'POST', body: formData, mode: 'no-cors' });
};
